import { render } from "./Page.vue?vue&type=template&id=81177264"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=81177264&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__